import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "motion/react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { pressReleases } from "./pressReleasesData";
import { Helmet } from "react-helmet";
const PressReleases = () => {
  const [selectedCategory] = useState("All Releases");

  const normalize = (value) => value.trim().toLowerCase();

  const filteredReleases =
    selectedCategory === "All Releases"
      ? pressReleases
      : pressReleases.filter(
          (post) => normalize(post.category) === normalize(selectedCategory),
        );

  return (
    <>
      <Helmet>
        <title>
          Press Releases & News | Comsense Technologies AI & Salesforce
        </title>

        <meta
          name="description"
          content="Explore Comsense press releases, company news & AI innovations. Stay updated on Salesforce, data & transformation insights."
        />

        <meta
          name="keywords"
          content="Comsense press releases, company news Pune, AI technology news India, Salesforce updates India"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Press Releases & News | Comsense Technologies AI & Salesforce"
        />
        <meta
          property="og:description"
          content="Latest company news, AI innovations & Salesforce updates from Comsense."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://comsensetechnologies.com/press-releases"
        />
      </Helmet>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
        .press-release-page { font-family: 'Outfit', sans-serif; background-color: #f8fafc; }
        .press-release-page * { font-family: 'Outfit', sans-serif; }

        .press-release-hero {
          padding: 100px 0 100px;
          background: #e2f1fe;
          color: #fff;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .hero-title-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          max-width: 600px;
        }

        .press-release-hero h1 {
          font-weight: 800;
          margin-bottom: 10px;
          font-size: 42px;
          text-align: left;
          color: #0f172a;
          letter-spacing: -.5px;
        }

        .press-release-hero p {
          font-size: 16px;
          color: #475569;
          text-align: left;
          max-width: 900px;
          margin-bottom: 0px;
        }

        .hero-monitor-icon {
          position: absolute;
          top: 50%;
          right: 10%;
          transform: translateY(-50%);
          opacity: 0.2;
          pointer-events: none;
        }

        .press-release-filter {
          padding: 60px 0 40px;
          display: flex;
          justify-content: flex-start;
          gap: 10px;
          flex-wrap: wrap;
          border-bottom: 1px solid #e2e8f0;
          margin-bottom: 40px;
        }

        .filter-label {
          font-weight: 700;
          margin-right: 20px;
          display: flex;
          align-items: center;
          color: #0f172a;
        }

        .filter-btn {
          padding: 8px 16px;
          border: 1px solid #e2e8f0;
          background: #fff;
          border-radius: 20px;
          cursor: pointer;
          font-weight: 500;
          font-size: 14px;
          white-space: nowrap;
          transition: all 0.3s ease;
          color: #475569;
        }

        .filter-btn:hover {
          border-color: #007bff;
          color: #007bff;
        }

        .filter-btn.active {
          background: #007bff;
          color: #fff;
          border-color: #007bff;
        }

        .press-release-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 30px;
            padding: 80px 0;
        }

        .press-release-grid > * {
          height: 100%;
        }

        .press-release-card {
          background: #fff;
        //   border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          text-decoration: none;
          color: inherit;
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .press-release-card:hover {
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          transform: translateY(-5px);
        }

        .press-release-card-image {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }

        .press-release-card-content {
          padding: 24px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }

        // .press-release-card-category {
        //   display: inline-block;
        //   background: #e0f2fe;
        //   color: #0369a1;
        //   padding: 4px 12px;
        //   border-radius: 15px;
        //   font-size: 12px;
        //   font-weight: 600;
        //   margin-bottom: 12px;
        //   width: fit-content;
        // }

        .press-release-card-title {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #0f172a;
          line-height: 1.4;
        }

        .press-release-card-excerpt {
          font-size: 14px;
          color: #64748b;
          margin-bottom: 12px;
          flex-grow: 1;
        }

        .press-release-card-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #94a3b8;
          margin-top: auto;
          padding-top: 12px;
        }

        .press-release-card-link {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #007bff;
          font-weight: 600;
          margin-top: 12px;
          text-decoration: none;
        }

        .press-release-card-link:hover {
          color: #0056b3;
        }

        .empty-state {
          text-align: center;
          padding: 60px 20px;
        }

        .empty-state h3 {
          color: #0f172a;
          margin-bottom: 10px;
        }

        .empty-state p {
          color: #64748b;
        }
      `}</style>

      <div className="press-release-page">
        {/* Hero Section */}
        <div className="press-release-hero">
          <Container>
            <Row>
              <Col lg={8}>
                <div className="hero-title-container">
                  <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    Press Releases
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                  >
                    Stay updated on the latest news and announcements from
                    Comsense.
                  </motion.p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Filter Section */}
        <Container>
          {/* <div className="press-release-filter">
            <span className="filter-label">Filter by:</span>
            {categories.map((category) => (
              <motion.button
                key={category.name}
                className={`filter-btn ${
                  selectedCategory === category.name ? "active" : ""
                }`}
                onClick={() => setSelectedCategory(category.name)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {category.name} ({category.count})
              </motion.button>
            ))}
          </div> */}

          {/* Press Releases Grid */}
          {filteredReleases.length > 0 ? (
            <div className="press-release-grid">
              {filteredReleases.map((release) => (
                <motion.div
                  key={release.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: true }}
                >
                  <Link
                    to={`/press-releases/${release.slug}`}
                    className="press-release-card"
                  >
                    <img
                      src={release.image}
                      alt={release.title}
                      className="press-release-card-image"
                    />
                    <div className="press-release-card-content">
                      {/* <span className="press-release-card-category">
                        {release.category}
                      </span> */}
                      <h3 className="press-release-card-title">
                        {release.title}
                      </h3>
                      <div className="press-release-card-meta">
                        {/* <span>{release.date}</span> */}
                        <span style={{ fontWeight: 600, color: "#ee0000" }}>
                          Open Press Release <ArrowRight size={14} />
                        </span>
                      </div>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <h3>No press releases found</h3>
              <p>Try adjusting your filters or check back later.</p>
            </div>
          )}
        </Container>
      </div>
    </>
  );
};

export default PressReleases;
